<template>
  <div :id="id" class="wang-editor" />
</template>

<script>
// import wangEditor from 'wangeditor'

// export default {
//   props: {
//     id: { type: String, default: () => (`id-${Math.random().toString().substring(2)}`) },
//     value: { type: String, default: () => '' },
//     height: { type: Number, default: () => 480 },
//     uploadUrl: { type: String, default: () => '' },
//     placeholder: { type: String, default: () => '请输入正文...' },
//     decsribe: { type: String, default: () => '兼容主流 PC 浏览器，IE11+, 不支持移动端和 ipad' },
//   },
//   data() {
//     return {
//       editor: null,
//       content: '',
//       autoHeight: 480,
//     }
//   },
//   mounted() {
//     this.create();
//   },
//   methods: {
//     create() {
//       const object = document.getElementById(this.id);
//       this.content = this.value; // 接收默认值
//       object.innerHTML = this.content; // 初始化默认值
//       const editor = new wangEditor(object); // 实例化编辑器
//       editor.config.height = this.height;
//       editor.config.onchangeTimeout = 100; // 监听响应延迟
//       editor.config.pasteIgnoreImg = false; // 忽略粘贴的图片
//       editor.config.pasteFilterStyle = false; // 关闭样式过滤
//       editor.config.placeholder = this.placeholder; // 输入提示
//       editor.config.uploadImgShowBase64 = true; // 使用 base64 格式保存图片
//       editor.config.uploadImgServer = this.uploadUrl; // 图片上传路径
//       editor.config.onchange = (content) => this.change(content);
//       this.$nextTick(() => {
//         editor.create();
//         this.$nextTick(() => this.editor = editor);
//       })
//     },
//     change(content) { // 双向绑定
//       this.$emit('input', content);
//     }
//   },
//   beforeDestroy() {
//     this.content = '';
//     this.editor.destroy();
//     this.editor = null;
//   }
// }
</script>

<style scoped>
@import "index.css";
</style>
